<template>
  <base-stack class="user-shows">
    <p v-if="$apollo.loading">Loading...</p>
    <p v-else-if="!userData || userData.shows.length === 0">No show participations found.</p>
    <base-stack as="ul" v-else>
      <user-show-cell
        v-for="participation in sortedShows"
        :key="participation.id"
        :participation="participation"
        :user-id="user.id"
      />
    </base-stack>
  </base-stack>
</template>

<script lang="ts">
import UserShowCell from '@/components/UserShowCell.vue';
import { ShowParticipant, User } from '@/types/api';
import gql from 'graphql-tag';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: { UserShowCell },
  apollo: {
    userData: {
      query: gql`
        query UserShows($id: ID!) {
          user(id: $id) {
            id
            shows {
              id
              hasEarlyEntry
              show {
                id
                showDate
                tourId
                address {
                  venue
                  city
                }
              }
              tickets {
                id
                createdAt
                usedAt
                refundedAt
                tier {
                  id
                  name
                }
              }
              meetAndGreetTickets {
                id
                quota
                createdAt
                confirmedAt
                declinedAt
                usedAt
                isValidFor
                purchases {
                  id
                  date
                  type
                  quantity
                  refundedAt
                }
              }
              attendance {
                createdAt
                appliedEarlyEntryAt
                appliedMeetAndGreetAt
                verifiedAt
              }
            }
          }
        }
      `,
      variables() {
        return { id: this.user.id };
      },
      update: (data) => data.user,
    },
  },
})
export default class UserShows extends Vue {
  @Prop({ type: Object, required: true }) public user!: User;

  userData: { shows: ShowParticipant[] } | null = null;

  get sortedShows() {
    if (!this.userData) return [];
    return [...this.userData.shows].sort((a, b) => {
      return new Date(b.show.showDate).getTime() - new Date(a.show.showDate).getTime();
    });
  }
}
</script>

<style lang="scss" scoped>
.user-shows {
  padding: 1rem 0;
}
</style>
